import { render, staticRenderFns } from "./IcoCalloutEllipsis.vue?vue&type=template&id=d568d614"
import script from "./IcoCalloutEllipsis.vue?vue&type=script&lang=js"
export * from "./IcoCalloutEllipsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports